import clsx from 'clsx';

import { useAccordionContext } from '../contexts/accordion-context';

export interface UseAccordionItemProps {
	as?: React.ElementType;
	className?: string;
	itemKey: string;
	children: React.ReactNode;
}

export const useAccordionItem = (props: UseAccordionItemProps) => {
	const { isAccordionItemExpanded } = useAccordionContext();
	const {
		as,
		className,
		itemKey,
		...other
	} = props;

	const Component = as || 'div';

	const getBaseProps = (props = {}) => {
		return {
			'data-expand': isAccordionItemExpanded(itemKey),
			className: clsx('accordion__item', className),
			...other,
			...props
		};
	};

	return {
		Component,
		itemKey,
		getBaseProps,
	};
};